var _title, _desc, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 35,
    viewBox: "0 0 134 35",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-1244 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill 14"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(1282.23 -25.5147)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 16"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(1308.93 -20.9222)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 18"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(1324.47 -26.0162)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 20"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(1330.43 -26.0162)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 22"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_fill",
    transform: "translate(1334.8 -25.2635)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 24"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_fill",
    transform: "translate(1342.69 -20.9221)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 26"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path5_fill",
    transform: "translate(1358.33 -20.7211)",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill 28"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path6_fill",
    transform: "translate(1364.85 -20.7211)",
    fill: "#020203"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2 Copy 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo Copy 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path7_fill",
    transform: "translate(1252.15 -5.98701)",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8_fill",
    transform: "translate(1253.31 -2.65937)",
    fill: "url(#paint9_linear)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path9_fill",
    transform: "translate(1244 -25.6366)",
    fill: "url(#paint10_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(1262.8 -25.6366)",
    fill: "url(#paint11_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_fill",
    transform: "translate(1246.16 -34.8927)",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path12_fill",
    transform: "translate(1255.91 -22.9677)",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path13_fill",
    transform: "translate(1257.46 -19.3057)",
    fill: "#1D1D1B"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-10.09 2.01236 -10.09 -2.01236 10.09 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.39042 18.0031 -9.39042 -18.0031 9.39042 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.39042 18.0031 -9.39042 -18.0031 9.39042 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    fillRule: "evenodd",
    d: "M 9.0731 0.150039L 9.62474 0.150039L 12.5071 6.82707L 15.4149 0.150039L 15.9668 0.150039L 12.7836 7.42955L 17.0449 17.1925L 24.5137 0L 25.0654 0L 17.3203 17.8196L 16.7684 17.8196L 12.5328 8.05664L 8.29697 17.8196L 7.74504 17.8196L 0 0L 0.551647 0L 8.02043 17.1925L 12.2574 7.42955L 9.0731 0.150039Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    fillRule: "evenodd",
    d: "M 11.8823 6.50116C 11.8314 5.63105 11.6477 4.82726 11.3307 4.09097C 11.0122 3.35584 10.5994 2.72353 10.0894 2.19666C 9.57939 1.66949 8.99072 1.255 8.32278 0.953763C 7.65369 0.652526 6.93571 0.502197 6.16653 0.502197C 5.39764 0.502197 4.67966 0.652526 4.01143 0.953763C 3.34263 1.255 2.75396 1.67384 2.24396 2.20882C 1.73397 2.74496 1.32928 3.38017 1.02814 4.11646C 0.727298 4.85275 0.551998 5.64727 0.501953 6.50116L 11.8823 6.50116ZM 6.26656 13.4783C 5.41493 13.4783 4.60814 13.2987 3.84822 12.9381C 3.08743 12.5787 2.42354 12.0854 1.85541 11.4574C 1.28727 10.8303 0.836582 10.1022 0.501891 9.27404C 0.16749 8.44564 0 7.56336 0 6.62692C 0 5.7067 0.159101 4.8447 0.476435 4.04092C 0.793769 3.2383 1.23318 2.5356 1.79321 1.93313C 2.35209 1.33066 3.00383 0.857656 3.74842 0.51471C 4.49099 0.172632 5.28939 0 6.14217 0C 7.00999 0 7.82488 0.175528 8.58596 0.528034C 9.34559 0.879091 10.0057 1.35615 10.5655 1.95775C 11.1255 2.56022 11.5721 3.2719 11.9068 4.09103C 12.2412 4.91103 12.4084 5.78954 12.4084 6.72685L 12.4084 7.0026L 0.501891 7.0026C 0.568135 7.83998 0.765131 8.62146 1.09143 9.34935C 1.41687 10.0775 1.83892 10.7087 2.3573 11.244C 2.87423 11.7801 3.47187 12.203 4.14907 12.5123C 4.82539 12.8217 5.54048 12.9761 6.29201 12.9761C 6.7939 12.9761 7.28249 12.9095 7.75863 12.7756C 8.23507 12.6421 8.68171 12.453 9.1 12.2111C 9.51713 11.9681 9.88509 11.6799 10.2024 11.345C 10.5198 11.0099 10.7706 10.6424 10.9543 10.24L 11.4304 10.3657C 11.2467 10.8182 10.9838 11.2315 10.641 11.6086C 10.2982 11.9843 9.89753 12.311 9.43758 12.5868C 8.97851 12.8637 8.47661 13.0812 7.93422 13.2394C 7.39039 13.3987 6.83469 13.4783 6.26656 13.4783Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    fillRule: "evenodd",
    d: "M 0 0L 0.500734 0L 0.500734 16.389C 0.500734 16.8742 0.651736 17.2591 0.952581 17.543C 1.25343 17.828 1.65436 17.9699 2.1551 17.9699C 2.33879 17.9699 2.56008 17.9494 2.82014 17.9065C 3.07817 17.8657 3.31682 17.8106 3.53407 17.7443L 3.70937 18.1455C 3.47477 18.2292 3.18723 18.3007 2.84444 18.3589C 2.50194 18.4172 2.2144 18.4467 1.9798 18.4467C 1.39517 18.4467 0.919025 18.259 0.551647 17.8822C 0.183689 17.5053 0 17.008 0 16.389L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    fillRule: "evenodd",
    d: "M 6.51736 16.966C 6.26656 17.1334 6.03687 17.2591 5.82802 17.3428C 5.61887 17.4266 5.37212 17.5062 5.08834 17.5809C 4.80398 17.6563 4.48665 17.6942 4.13576 17.6942C 3.53407 17.6942 3.00788 17.5103 2.5569 17.1415C 2.10505 16.774 1.87971 16.2888 1.87971 15.6863L 1.87971 5.04485L 0 5.04485L 0 4.5426L 1.87971 4.5426L 1.87971 0L 2.3816 0L 2.3816 4.5426L 5.51473 4.5426L 5.51473 5.04485L 2.3816 5.04485L 2.3816 15.6863C 2.41429 16.1715 2.60694 16.5443 2.95783 16.8027C 3.30872 17.063 3.70127 17.1917 4.13576 17.1917C 4.41925 17.1917 4.6877 17.163 4.93763 17.1039C 5.18843 17.0457 5.40972 16.9782 5.60238 16.9037C 5.79417 16.8281 5.94401 16.7578 6.05336 16.6903C 6.16155 16.6239 6.22461 16.5811 6.2411 16.5646L 6.51736 16.966Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    fillRule: "evenodd",
    d: "M 0.501953 6.80239C 0.501953 7.63891 0.651797 8.43342 0.952643 9.18593C 1.25378 9.9396 1.65847 10.5962 2.16846 11.1558C 2.67846 11.7178 3.2761 12.1609 3.96168 12.4868C 4.64581 12.8124 5.38115 12.9757 6.16653 12.9757C 6.93571 12.9757 7.667 12.8095 8.36039 12.4743C 9.05291 12.1395 9.66386 11.6879 10.1903 11.1194C 10.7165 10.5505 11.1296 9.88863 11.4305 9.13582C 11.7313 8.38331 11.8823 7.57953 11.8823 6.7268C 11.8823 5.89028 11.7313 5.0949 11.4305 4.3421C 11.1296 3.58959 10.7206 2.92889 10.2025 2.36002C 9.6844 1.79114 9.07837 1.33871 8.38498 1.00387C 7.69129 0.669905 6.96001 0.502197 6.19198 0.502197C 5.42309 0.502197 4.69181 0.669905 3.99813 1.00387C 3.30473 1.33871 2.69899 1.7952 2.18177 2.37218C 1.66368 2.94917 1.25378 3.61913 0.952643 4.38004C 0.651797 5.14183 0.501953 5.9485 0.501953 6.80239ZM 6.19192 13.4783C 5.33943 13.4783 4.53785 13.2987 3.78516 12.9381C 3.03333 12.5787 2.37755 12.0935 1.81751 11.4829C 1.25777 10.872 0.814887 10.1572 0.489742 9.33719C 0.163151 8.51719 0 7.65518 0 6.75147C 0 5.83212 0.163151 4.96635 0.489742 4.15446C 0.814887 3.34257 1.26182 2.62771 1.83082 2.00873C 2.3978 1.38975 3.05879 0.899656 3.81061 0.540199C 4.56215 0.180742 5.35563 0 6.19192 0C 7.02735 0 7.82083 0.180742 8.57265 0.540199C 9.32535 0.899656 9.98113 1.38975 10.5409 2.00873C 11.1 2.62771 11.5476 3.34257 11.8822 4.15446C 12.2158 4.96635 12.383 5.83212 12.383 6.75147C 12.383 7.65518 12.2198 8.51719 11.8944 9.33719C 11.5681 10.1572 11.1255 10.872 10.5655 11.4829C 10.0054 12.0935 9.34964 12.5787 8.59811 12.9381C 7.84628 13.2987 7.04355 13.4783 6.19192 13.4783Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5_fill",
    fillRule: "evenodd",
    d: "M 5.56478 0.502544C 4.3287 0.552654 3.26273 0.953821 2.36945 1.70662C 1.47501 2.46029 0.852782 3.48856 0.501891 4.79372L 0.501891 13.0262L 0 13.0262L 0 0L 0.501891 0L 0.501891 3.36314C 0.952581 2.44292 1.55861 1.68606 2.3194 1.09169C 3.07933 0.498489 3.88612 0.151198 4.73774 0.0501096C 4.90494 0.0338892 5.05999 0.0214342 5.20174 0.012455C 5.34348 0.00405511 5.46469 0 5.56478 0L 5.56478 0.502544Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6_fill",
    fillRule: "evenodd",
    d: "M 2.68244 18.1211C 2.96593 18.1211 3.21268 18.109 3.42183 18.0835C 3.62982 18.0577 3.77677 17.9873 3.86037 17.87C 3.91041 17.8199 3.96856 17.7237 4.03596 17.5818C 4.1022 17.439 4.21126 17.196 4.3611 16.8536C 4.51211 16.5107 4.72038 16.0336 4.98854 15.423C 5.25583 14.8122 5.60643 14.0136 6.04092 13.0262L 0 0L 0.551936 0L 6.29201 12.3991L 11.7312 0L 12.282 0L 4.53669 17.6942C 4.3368 18.1293 4.06026 18.3969 3.70937 18.498C 3.37497 18.5808 3.03333 18.6225 2.68244 18.6225L 2.68244 18.1211Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7_fill",
    fillRule: "evenodd",
    d: "M 0 1.08553C 0 1.68505 0.486007 2.17105 1.08553 2.17105L 11.1643 2.17105C 11.7638 2.17105 12.2498 1.68505 12.2498 1.08553C 12.2498 0.486007 11.7638 0 11.1643 0L 1.08553 0C 0.486007 0 0 0.486007 0 1.08553Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8_fill",
    fillRule: "evenodd",
    d: "M 0 1.00618C 0 1.56188 0.450483 2.01236 1.00618 2.01236L 9.08382 2.01236C 9.63952 2.01236 10.09 1.56188 10.09 1.00618C 10.09 0.450483 9.63952 0 9.08382 0L 1.00618 0C 0.450483 0 0 0.450483 0 1.00618Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9_fill",
    d: "M 7.90895 17.897C 8.42014 18.1503 9.03665 17.9346 9.28597 17.4152C 9.53529 16.8959 9.32301 16.2695 8.81182 16.0162C 3.43865 13.3535 0.829678 7.09365 2.62181 1.36343C 2.79405 0.812713 2.49427 0.224408 1.95224 0.0494128C 1.4102 -0.125583 0.831167 0.178999 0.65893 0.729714C -1.44152 7.44574 1.61426 14.7777 7.90895 17.897Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10_fill",
    d: "M 0.578599 16.0162C 0.067416 16.2695 -0.144865 16.8959 0.104455 17.4152C 0.353776 17.9346 0.970285 18.1503 1.48147 17.897C 7.77617 14.7777 10.8319 7.44574 8.73149 0.729714C 8.55926 0.178999 7.98022 -0.125583 7.43819 0.0494128C 6.89615 0.224408 6.59637 0.812713 6.76861 1.36343C 8.56074 7.09365 5.95177 13.3535 0.578599 16.0162Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11_fill",
    d: "M 23.6032 6.32661C 22.2329 4.24995 20.3476 2.56852 18.088 1.44881C 11.7099 -1.7118 4.03663 0.455326 0.16968 6.42542C -0.142975 6.90812 -0.0112926 7.55694 0.463802 7.87461C 0.938897 8.19227 1.57749 8.05848 1.89015 7.57578C 5.18953 2.48194 11.7408 0.631699 17.1851 3.32961C 19.1158 4.28633 20.7233 5.71996 21.8925 7.49189C 21.9211 7.53521 21.9494 7.57872 21.9774 7.62241C 22.2881 8.10646 22.9261 8.24301 23.4025 7.92741C 23.8789 7.61181 24.0133 6.96356 23.7027 6.47951C 23.6699 6.42833 23.6367 6.37736 23.6032 6.32661Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12_fill",
    fillRule: "evenodd",
    d: "M 2.2312 0C 0.998901 0 0 1.01495 0 2.26696C 0 3.51897 0.998901 4.53392 2.2312 4.53392C 3.4635 4.53392 4.46252 3.51897 4.46252 2.26696C 4.46252 1.01495 3.4635 0 2.2312 0ZM 2.2312 1.2207C 2.79993 1.2207 3.26099 1.68914 3.26099 2.26699C 3.26099 2.84484 2.79993 3.31328 2.2312 3.31328C 1.66248 3.31328 1.20142 2.84484 1.20142 2.26699C 1.20142 1.68914 1.66248 1.2207 2.2312 1.2207Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13_fill",
    fillRule: "evenodd",
    d: "M 0 0.686533C 0 0.307371 0.307371 0 0.686533 0C 1.0657 0 1.37307 0.307371 1.37307 0.686533L 1.37307 10.4739C 1.37307 10.8531 1.0657 11.1604 0.686533 11.1604C 0.307371 11.1604 0 10.8531 0 10.4739L 0 0.686533Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.47639dac.svg";
export { ForwardRef as ReactComponent };